import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, Shield } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';
import { formatApiError } from '../lib/format';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/admin/login', {
        email: email.trim().toLowerCase(),
        password,
      });
      login(data.token, data.user);
      toast.success('Admin authenticated');
      navigate('/admin');
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-4 sm:px-6 py-20">
      <div className="card-embossed p-8 sm:p-10">
        <div className="flex items-center gap-2 mb-3">
          <Shield className="text-[#D4AF37]" size={20} />
          <p className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold">Admin</p>
        </div>
        <h1 className="font-serif-display text-3xl font-black text-gold-gradient">Restricted access</h1>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#C0C0C0]/80">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              required
              autoComplete="email"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
              placeholder="admin@goldenfish.co.za"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#C0C0C0]/80">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-submit"
            className="btn-gold w-full inline-flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="animate-spin" size={18} />}
            Enter Admin
          </button>
        </form>
      </div>
    </div>
  );
}
